<app-header></app-header>

<!-- Calculator Section -->
<section class="py-5" id="calculator">
    <div class="container main-container">
        <div class="row align-items-center">
            <div class="col-lg-6 mb-4 mb-lg-0">
                <h2 class="display-5 quicksand">
                    Calculate how much <strong>revenue</strong> you can earn from<br />
                    listing with ParkUpp
                </h2>
            </div>
            <div class="col-lg-6">
                <div class="card border-0 shadow">
                    <div class="card-body p-4">
                        <form [formGroup]="calculatorForm" (ngSubmit)="calculateRevenue()">
                            <div class="mb-3">
                                <div class="calculator-label">Number Of Bays</div>
                                <input type="number" min="0" step="1" class="form-control form-control-lg" formControlName="numBays" placeholder="Enter number of bays" />
                            </div>
                            <div class="mb-3">
                                <div class="calculator-label">Cost Per Bay (Monthly)</div>
                                <input type="number" min="0" step="50" class="form-control form-control-lg" formControlName="costPerBay" placeholder="Enter cost per bay" />
                            </div>
                            <div class="mb-3">
                                <div class="calculator-label">Number Of Months</div>
                                <input type="number" min="1" step="1" class="form-control form-control-lg" formControlName="numMonths" placeholder="Enter number of months" />
                            </div>
                            <div class="d-flex align-items-center justify-content-between">
                                <button type="submit" class="btn btn-custom btn-lg fw-bold text-white">
                                    <i class="bi bi-calculator ms-2"></i>
                                    Calculate
                                </button>
                                <div class="fs-2 fw-bold text-dark">{{ calculatedRevenue }}</div>
                            </div>
                        </form>
                    </div>
                </div>
                <small class="text-black">
                    <em>Net after ParkUpp's monthly service, banking and marketing fee.</em>
                </small>
                <!-- <div class="mt-3 text-center">
                    <small class="text-black">
                        <em>ParkUpp takes a 15% monthly service fee from all parking booked through our platform</em>
                    </small>
                </div> -->
            </div>
        </div>
    </div>
</section>

<div class="container-fluid p-0 customer-logos bg-grey">
    <div class="row">
        <app-logo-slider></app-logo-slider>
    </div>
</div>

<div class="jumbotron jumbotron-fluid">
    <div class="container flex-item mx-3 mx-md-5">
        <div class="row">
            <div class="col-12">
                <h4 class="text-center text-capitalize text-white">Welcome to</h4>
                <h1 class="hero-header text-light text-center extra-large py-4">Frictionless Leasing</h1>
                <p class="text-center text-white-50">
                    Parking is evolving into a fast moving commodity. In many locations, spaces are limited and demand on the increase. Our Paygate system allows us to debit the Parker monthly in
                    advance for the duration of their commitment. When the payments run out, we’ll notify you to deactivate access.
                </p>
                <br />
                <div class="call-to-action text-center">
                    <button class="btn btn-primary" (click)="listParking()">List a Parking</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- YouTube -->
<!--<div class="section-youtube container position-relative my-md-5">-->
<!--    <div class="embed-responsive embed-responsive-16by9 text-center">-->
<!--        <iframe width="1000" height="562" src="https://www.youtube.com/embed/YuqocBhOkB8"-->
<!--                title="The VC4A Founder Series #9 | Palesa Moloi of ParkUpp" frameborder="0"-->
<!--                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"-->
<!--                allowfullscreen></iframe>-->
<!--    </div>-->
<!--</div>-->

<div class="parkupp-way container-fluid py-md-5 bg-dark-blue">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="text-light">The ParkUpp Way</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-4 p-2 d-flex flex-column">
                <div class="block">
                    <h4 class="text-primary mb-3 mt-1">WHAT</h4>
                    <hr />
                    <div class="text-light">ParkUpp is a leading independent digital monthly parking platform that allows landlords to rent out idle parking spaces and increase rental income.</div>
                    <br />
                    <div class="text-light">Currently serving Cape Town, Durban, Johanessburg and Pretoria areas.</div>
                </div>
            </div>

            <div class="col-12 col-lg-4 p-2 d-flex flex-column">
                <div class="block">
                    <h4 class="text-primary mb-3 mt-1">WHO</h4>
                    <hr />
                    <div class="text-light">We have a young, diverse and dynamic team which is spread out across South Africa.</div>
                    <br />
                    <div class="text-light">
                        Although we are a technology-based company which aims for the most seamless possible digital solution... We also believe that there is no substitute for inter-human connection
                    </div>
                    <br />
                    <div class="text-light">- and we are big on retaining this at ParkUpp!</div>
                </div>
            </div>

            <div class="col-12 col-lg-4 p-2 d-flex flex-column">
                <div class="block">
                    <h4 class="text-primary mb-3 mt-1">HOW</h4>
                    <hr />
                    <div class="text-light">ParkUpp makes it easy for you to rent out your idle parking spaces:</div>
                    <br />
                    <div class="text-light">
                        <ul>
                            <li>List your available parking bays on our platform.</li>
                            <li>Utilise our marketing efforts to attract suitable renters and manage revenue collection on your behalf.</li>
                            <li>We collect payment from parkers on your behalf.</li>
                            <li>A 15% fee is applied for these comprehensive management services.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 py-5 text-center">
                <div class="call-to-action text-center">
                    <button class="btn btn-primary" (click)="listParking()">List a Parking</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="listing-options container-fluid py-md-5 bg-yellow">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="mb-4">What Are My Listing Options</h1>
                <p class="text-black">
                    <b>An income producing parking bay is an asset, a vacant one a liability.</b> List vacant parking, leverage our marketing, client base, digital booking and payment systems to
                    maximise the value of your parking asset. Browse our listings to establish market related parking rentals. Leverage ParkUpps software to allocate parking, oversee bookings, monitor
                    Parker payments and share your parking opportunity exclusively amongst your tenants.
                </p>
            </div>
        </div>
        <div class="row pb-4">
            <div class="col-12 col-lg-4 p-2 d-flex flex-column">
                <div class="block">
                    <h2 class=""><span class="header-part-light">ParkUpp</span>&nbsp;<span class="header-part-bold">Monthly</span>&nbsp;</h2>
                    <hr />
                    <div class="">Monthly encourages medium to long term parking commitments from corporates and or individuals.</div>
                    <br />
                    <div class="">The choice of who parks in your bays and for how long is yours.</div>
                </div>
            </div>

            <div class="col-12 col-lg-4 p-4 p-md-2 d-flex justify-content-center align-items-center">
                <div class="circle d-flex justify-content-center align-items-center">
                    <h1 class="text-white">VS</h1>
                </div>
            </div>

            <div class="col-12 col-lg-4 p-2 d-flex flex-column mb-4 mb-md-0">
                <div class="block">
                    <h2 class=""><span class="header-part-light">ParkUpp</span>&nbsp;<span class="header-part-bold">Flex</span>&nbsp;</h2>
                    <hr />
                    <div class="">Flex allows you to list parking available on a month by month basis. Users are aware that what is available this month may no longer be next.</div>
                    <br />
                    <div class="">Perfect for those months before tenants take occupation.</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="why-list py-md-5 bg-dark-blue">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="text-white"><span class="header-part-light">Why List with</span>&nbsp;<span class="header-part-bold">ParkUpp?</span>&nbsp;</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6 mt-4 mt-lg-0 px-5 py-3 p-md-5">
                <img class="tick-icon" src="assets/images/home/ticks.svg" />
                <h4 class="standard-font text-primary mb-3 mt-2">PAYMENT IN ADVANCE</h4>
                <div class="text-light">ParkUpp’s parkers pay for parking monthly in advance before they park.</div>
            </div>

            <div class="col-12 col-lg-6 mt-4 mt-lg-0 px-5 py-3 p-md-5">
                <img class="tick-icon" src="assets/images/home/ticks.svg" />
                <h4 class="standard-font text-primary mb-3 mt-2">YOU'RE IN CONTROL</h4>
                <div class="text-light">
                    ParkUpp requires parkers to provide you with their personal detail when they apply to you to park in your spaces. Don’t like what you see, no longer have available spaces or want a
                    longer/shorter commitment ….simply reject the request.
                </div>
            </div>

            <div class="col-12 col-lg-6 mt-4 mt-lg-0 px-5 py-3 p-md-5">
                <img class="tick-icon" src="assets/images/home/ticks.svg" />
                <h4 class="standard-font text-primary mb-3 mt-2">REDUCE ADMIN</h4>
                <div class="text-light">
                    You can add your T&C’s and traditional lease terms as a condition which parkers must acknowledge and accept as part of ParkUpp’s booking process. A paperless, digital "effective
                    lease” reducing your administration burden.
                </div>
            </div>

            <div class="col-12 col-lg-6 mt-4 mt-lg-0 px-5 py-3 p-md-5">
                <img class="tick-icon" src="assets/images/home/ticks.svg" />
                <h4 class="standard-font text-primary mb-3 mt-2">STAND-OUT CUSTOMER SERVICE</h4>
                <div class="text-light">Benefit from our dedicated sales team for effective and efficient administration and prompt assistance with any special requests.</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 py-5 text-center">
                <button class="btn btn-primary" (click)="listParking()">List a Parking</button>
            </div>
        </div>
    </div>
</div>

<div class="landlord-process py-md-5 bg-grey">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-light">The Landlord Process</span>
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="fa-4x d-flex position-relative">
                    <i class="fas fa-map-marker text-danger position-absolute top-50 start-50 translate-middle"></i>
                    <h1 class="marker-text position-absolute top-50 start-50 translate-middle">1</h1>
                </div>

                <div class="after-marker">
                    <h3 class="mb-3 mt-2">List Your Property</h3>
                    <div class="">
                        List your property on our website through a simple step-by-step process, including the building name, location, number of bays, and your banking details for payouts. If you
                        have photos, you can provide those. If not, we can arrange for a photographer to take them for you.
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="fa-4x d-flex position-relative">
                    <i class="fas fa-map-marker text-danger position-absolute top-50 start-50 translate-middle"></i>
                    <h1 class="marker-text position-absolute top-50 start-50 translate-middle">2</h1>
                </div>

                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Receive Request</h3>
                    <div class="">
                        Once a renter confirms a booking, we send a booking confirmation email to the building manager or your designated representative for approval and access arrangement. The renter
                        will receive a sticker for easy identification.
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="fa-4x d-flex position-relative">
                    <i class="fas fa-map-marker text-danger position-absolute top-50 start-50 translate-middle"></i>
                    <h1 class="marker-text position-absolute top-50 start-50 translate-middle">3</h1>
                </div>

                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Confirm Parker</h3>
                    <div class="">After the booking is approved by you, the landlord, ParkUpp will debit the payment from the renter and make a same-day payout, net of fees, to you.</div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <div class="fa-4x d-flex position-relative">
                    <i class="fas fa-map-marker text-danger position-absolute top-50 start-50 translate-middle"></i>
                    <h1 class="marker-text position-absolute top-50 start-50 translate-middle">4</h1>
                </div>

                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Monthly Statement</h3>
                    <div class="">At the end of the month, you will receive a statement summary from ParkUpp.</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 py-5 text-center">
                <button class="btn btn-primary" (click)="listParking()">List a Parking</button>
            </div>
        </div>
    </div>
</div>

<app-testimonials-block [header]="'What Our Clients Say'"></app-testimonials-block>

<section id="faq" class="faqs bg-grey pb-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-light">Frequently Asked Questions</span>
                </h1>
            </div>
        </div>

        <div class="row faq-inner">
            <div class="col-12 px-md-5">
                <div class="faq-list">
                    <ul class="list-unstyled">
                        <ng-container *ngFor="let faq of merchantFaqs; let i = index">
                            <li data-aos="fade-up" data-aos-delay="200" class="aos-init aos-animate">
                                <i class="fas fa-caret-right"></i>
                                <a data-bs-toggle="collapse" [attr.data-bs-target]="'#merchant-faq-list-' + i" class="collapsed">
                                    {{ faq.question }}

                                    <i class="bx bx-chevron-down icon-show"></i>

                                    <i class="bx bx-chevron-up icon-close"></i>
                                </a>
                                <div ckass="faq-content" id="merchant-faq-list-{{ i }}" class="collapse" data-bs-parent=".merchant-faq-list">
                                    <p class="mt-3 mb-5" [innerHTML]="faq.answer | safe: 'html'"></p>
                                </div>

                                <hr />
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="contact-form my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-light">Contact Us</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                We’d love to get your parking issues sorted - whether you’re looking to list 5 bays or 500 bays, we’ll help connect you to interested parkers. Please reach out to us via our online
                form.
                <br />
                <br />
                Alternately, you can reach out to us on Whatsapp via our website, email one of our business developement leads below or set up a video call.
                <br /><br />
                <div>
                    <h6 class="text-primary">Gauteng Enquiries</h6>
                    <b>Kwanele</b>
                    <br />
                    E: <a class="" href="mailto:kwanele@parkupp.co.za">kwanele&#64;parkupp.co.za</a>
                    <br />
                    T: <a class="" href="tel:+27 71 402 1338">071 402 1338</a>
                </div>
                <br />
                <br />
                <div>
                    <h6 class="text-primary">Cape Town and Durban Enquiries</h6>
                    <b>Umar</b>
                    <br />
                    E: <a class="" href="mailto:umar@parkupp.co.za">umar&#64;parkupp.co.za</a>
                    <br />
                    T: <a class="" href="tel:+27 71 280 2308">071 280 2308</a>
                    <br />
                    <br />
                    <a class="btn btn-outline-primary mt-3" href="https://calendly.com/kwanele-parkupp/15min" routerLinkActive="active"> Set Up a Video Call </a>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <ng-container *ngIf="formComplete">
                    <div class="alert alert-success" role="alert">We have received your enquiry. We will contact you soon.</div>
                    <a [routerLink]="'/corporate'" class="link-primary">Click here to send another enquiry</a>
                </ng-container>
                <ng-container *ngIf="!formComplete">
                    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Name</label>
                                <input type="text" class="form-control" formControlName="name" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Email Address</label>
                                <input type="email" class="form-control" formControlName="email" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Phone</label>
                                <input type="text" class="form-control" formControlName="phone" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">How many parking bays?</label>
                                <input type="text" class="form-control" formControlName="bays" />
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">What is your Location, Building or City or City</label>
                            <input type="text" class="form-control" formControlName="location" />
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Any additional information</label>
                            <textarea rows="5" type="text" class="form-control" formControlName="detail"></textarea>
                        </div>

                        <ng-container *ngIf="formError">
                            <div class="alert alert-danger pa-3" role="alert">
                                <pre>{{ formError }}</pre>
                            </div>
                        </ng-container>

                        <ng-container [ngTemplateOutlet]="formLoading ? formInvalidTemplate : validTemplate"></ng-container>
                        <ng-template #formSubmittingTemplate>
                            <button class="btn btn-primary" type="submit" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        </ng-template>
                        <ng-template #formInvalidTemplate>
                            <button class="btn btn-primary" type="submit" disabled>Submit</button>
                        </ng-template>
                        <ng-template #validTemplate>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </ng-template>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
